import { LocationManagementLocationKind } from "./locationKind";

export type KindMovementRule = {
  id: string;
  fromLocationKindId: string;
  toLocationKindId: string;
  fromLocationKind?: LocationManagementLocationKind;
  toLocationKind?: LocationManagementLocationKind;
};

export const defaultKindMovementRule: KindMovementRule = {
  id: "",
  fromLocationKindId: "",
  toLocationKindId: "",
};
